export const isMacOS = () => navigator.userAgent.includes('Macintosh');
